import { WORKSPACE_AGENT_UPDATE_CUSTOM_FIELDS_SAMPLE_FIELD_NAME } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentImprovedNullState';
import { usePrivateCustomFieldsContext } from '~/providers/PrivateCustomFieldsProvider';

export const usePrivateWorkspaceAgentUpdateCustomFieldsPromptCard = () => {
  const { customFields, isReady } = usePrivateCustomFieldsContext();
  const firstCustomFieldName = customFields?.[0]?.name;

  return {
    fieldName: firstCustomFieldName || WORKSPACE_AGENT_UPDATE_CUSTOM_FIELDS_SAMPLE_FIELD_NAME,
    isPending: !isReady,
  };
};
